window.select2 = require('select2');

novatio.bindSelect2 = function () {

    $('select.select2').each(function () {
        // default options.
        var options = {};

        if ($(this).data('placeholder')) {
            jQuery.extend(options, {
                placeholder: $(this).data('placeholder')
            });
        }

        if ($(this).data('thumbnails')) {
            var thumbs = $(this).data('thumbnails');
            jQuery.extend(options, {
                templateResult: function formatState(state) {
                    if (!state.id) {
                        return state.text;
                    }
                    return $(
                        '<span class="thumbitem">' +
                        '  <img src="' + thumbs[state.element.value] + '" class="select2-thumb" />' +
                        '  <span>' + state.text + '</span> ' +
                        '</span>'
                    );
                }
            });

            var logopreview = $(this).parents('.logo-preview-holder').find('.logo-preview');
            var images = logopreview.data('images');
            $(this).on('change', function () {
                if (images && typeof images[$(this).val()] !== 'undefined') {
                    logopreview.html('<img src="' + images[$(this).val()] + '" class="img-responsive">');
                }
            });
        }

        if ($(this).data('url')) {
            jQuery.extend(options, {
                escapeMarkup: function (markup) {
                    return markup;
                },
                minimumInputLength: 3,
                templateResult: function (repo) {
                    if (repo.loading) return repo.text;

                    if (typeof repo.label === 'undefined' && typeof repo.title !== 'undefined') {
                        repo.label = repo.title;
                    }

                    if (typeof repo.label === 'undefined' && typeof repo.name !== 'undefined') {
                        repo.label = repo.name;
                    }

                    var template = "<div class='select2-result-repository clearfix'>";
                    var noThumbClass = 'no-thumb';

                    if (repo.image) {
                        template += "<div class='select2-result-repository__avatar'>" +
                            "        <img src='" + repo.image + "' />" +
                            "    </div>";
                        noThumbClass = '';
                    }


                    template += "    <div class='select2-result-repository__meta " + noThumbClass + "'>" +
                    "        <div class='select2-result-repository__title'>" + repo.label + "</div>" +
                    "    </div>" +
                    "</div>";

                    return template;
                },
                templateSelection: function (repo) {
                    // console.log('repo', repo);
                    return repo.title || repo.name || repo.id || repo.text;
                },
                ajax: {
                    url: $(this).data('url'),
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q: params.term,
                            page: params.page
                        };
                    },
                    processResults: function (data, params) {
                        params.page = params.page || 1;

                        return {
                            results: data.data,
                        };
                    },
                    cache: false
                }
            });
        }

        $(this).select2(options);
    });
};


(function ($) {
    $(document).ready(function () {

        //creating new inputs for the order items
        var i = 0;
        $('#add-item-form').click(function () {
            i++;
            $('#order-items').append(
                '<tbody id="row' + i + '"><tr>' +
                '<td>' +
                '<input id="order_name"  type="text" name="order_name[]" class="form-control form-control-sm"/>'
                + '</td>'
                + '<td>'
                + '<input type="number" id="credit_price" name="credit_price[]" step="0.01" class="form-control text-right form-control-sm"/>'
                + '</td>'
                + '<td style="width: 77px;">'
                + '<a id="delete' + i + '" style="cursor:pointer;"><i class="icon-trash"></i></a>'
                + '</td>'
                + '</tr></tbody>'
            );

            $('#delete' + i).click(function () {
                $(this).parent().parent().remove();
            });


        });

// register
        if ($('select.select2').length) {
            novatio.bindSelect2();
        }
        /**
         * Handle the impersonation select
         */
        $(document).on('change', 'select[name="impersonating_user_id"]', function () {
            $(this).closest('form').submit();
        });
    });
}(jQuery));
